/**
 * KAN-444: the ONE definition of "this submission is not finally graded yet".
 *
 * quiz_submissions.grading_status takes four values (migration 019):
 *   - 'pending_manual' / 'partial' — a human still has to grade something
 *   - 'auto_graded' / 'completed'  — final
 *
 * A submission in the first group carries `passed: false` simply because
 * nothing has been graded, so any surface that renders a verdict straight off
 * `passed` manufactures a FAIL out of the absence of a result. That is the
 * KAN-444 defect, and it appeared on two independent surfaces at once (the
 * learner's split-screen quiz panel and the instructor's Quiz Submissions
 * table), so the predicate lives here rather than being spelled out at each
 * call site and drifting.
 *
 * Absent/unknown reads as FINAL: an older payload that omits the field must
 * keep its pre-existing pass/fail behavior rather than silently suppressing
 * every verdict in the app.
 */
export function isAwaitingGrading(gradingStatus: string | null | undefined): boolean {
  return gradingStatus === 'pending_manual' || gradingStatus === 'partial';
}
